import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApplyPipeModule } from '../apply/apply.module';
import { PowerStateModeOneComponent } from './power-state-mode-one/power-state-mode-one.component';
import { PowerStateModeTwoComponent } from './power-state-mode-two/power-state-mode-two.component';
import { PowerStateModeZeroComponent } from './power-state-mode-zero/power-state-mode-zero.component';
import { PowerStateComponent } from './power-state/power-state.component';
import { MeasuresModule } from '../measures/measures.module';
import { TimeAgoPipeModule } from '../time-ago-pipe/time-ago.module';

@NgModule({
  imports: [
    ApplyPipeModule,
    CommonModule,
    IonicModule,
    MeasuresModule,
    TimeAgoPipeModule,
  ],
  declarations: [
    PowerStateComponent,
    PowerStateModeOneComponent,
    PowerStateModeTwoComponent,
    PowerStateModeZeroComponent,
  ],
  exports: [
    PowerStateComponent,
    PowerStateModeOneComponent,
    PowerStateModeTwoComponent,
    PowerStateModeZeroComponent,
  ],
})
export class PowerStateModule { }
